export const VOICE_IDLE_MS=5*60*1000;
type Options={isBusy:()=>boolean;onIdle:()=>void};
/** Only intentional interaction renews the deadline. Never cut speech or playback. */
export function createVoiceIdleTimeout({isBusy,onIdle}:Options){
 let timer:ReturnType<typeof setTimeout>|undefined,lastActivity=0,running=false,epoch=0;
 const clear=()=>{clearTimeout(timer);timer=undefined;};
 const arm=(delay:number)=>{
  clear();const current=epoch;
  timer=setTimeout(()=>{
   if(!running||current!==epoch)return;
   const remaining=VOICE_IDLE_MS-(Date.now()-lastActivity);
   if(remaining>0){arm(remaining);return;}
   if(isBusy()){arm(1000);return;}
   running=false;clear();onIdle();
  },delay);
 };
 return {
  start(){epoch++;running=true;lastActivity=Date.now();arm(VOICE_IDLE_MS);},
  touch(){if(running){lastActivity=Date.now();arm(VOICE_IDLE_MS);}},
  stop(){epoch++;running=false;clear();},
 };
}
